module.exports = __webpack_public_path__ + "static/media/bn-mockup-1.2a03541f.jpg";